import { AlertButton } from 'react-native';

export type AlertRequest = {
  title: string;
  message?: string;
  buttons?: AlertButton[];
};

type Listener = () => void;

const queue: AlertRequest[] = [];
const listeners = new Set<Listener>();

const notify = () => {
  listeners.forEach((l) => l());
};

export const alertEmitter = {
  enqueue(req: AlertRequest) {
    queue.push(req);
    notify();
  },
  peek(): AlertRequest | undefined {
    return queue[0];
  },
  shift() {
    queue.shift();
    notify();
  },
  subscribe(listener: Listener): () => void {
    listeners.add(listener);
    return () => {
      listeners.delete(listener);
    };
  },
};
